// import packages
import React, {Component} from "react";
import {connect} from "react-redux";

//Import Components;
import Services from "../components/homepage/Services";
import About from "../components/homepage/About";
import Partners from "../components/Partners";

// Import utils
import {getPropsFromState} from "../redux/mapStateToProps";
import MainBlock from "../components/homepage/MainBlock";
import Consultation from "../components/homepage/Consultation";
import Project from "../components/homepage/Project";
import Subscribe from "../components/Contacts";


class Homepage extends Component {
    render() {
        const { services, partners, staticTexts,contacts,projects,requestLoading} = this.props;

        return <div className="homepage-wrapper">
            <MainBlock staticTexts={staticTexts} contacts={contacts}/>
            <Partners partners={partners?.partners} staticTexts={staticTexts}/>
            <Services services={services?.services} staticTexts={staticTexts}/>
            <About staticTexts={staticTexts}/>
            <Project projects={projects} staticTexts={staticTexts}/>
            <Consultation staticTexts={staticTexts}/>
            <Subscribe requestLoading={requestLoading} staticTexts={staticTexts}/>
        </div>
    }
}


const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'services',
        'partners',
        'about',
        'requestLoading',
        'staticTexts',
        'contacts',
        'projects',
    ])
};

const mapDispatchToProps = {};


export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
